import { ViewModel } from './model';
import html from './template.html';
import './style.less';

ko.components.register('media-preview', {
  viewModel: {
    createViewModel: (params, componentInfo) => {
      let element = componentInfo.element;
      element.classList.add('foquz-media-preview');

      return new ViewModel(params, element);
    },
  },
  template: html,
});
